<template>
  <v-chip
    v-bind="{
      ...$props,
      ...$attrs,
    }"
    :color="getChipColor"
    class="px-4"
    :class="{ 'reduce-font': reduceFontSize, 'is-active': isActive }"
    variant="flat"
    :pill="isPill"
    :label="!isPill"
    :style="{ height: `${chipHeight}px` }"
  >
    <slot name="pre-icon" />
    <slot name="label" />
    <div
      v-if="arrow"
      class="ml-1"
    >
      <v-icon
        icon="$chevron-down"
        :style="{
          transition: 'transform .2s',
          transform: isActive ? 'rotate(180deg)' : '',
          marginBottom: isActive ? '2px' : '0px',
        }"
      />
    </div>
    <slot />
  </v-chip>
</template>

<script>
export default {
  name: 'DpplChip',
  props: {
    isActive: { type: Boolean, default: false },
    arrow: { type: Boolean, default: false },
    chipHeight: { type: Number, default: 40 },
    isPill: { type: Boolean, default: true },
    chipColor: { type: String, default: 'bgDark' },
    reduceFontSize: { type: Boolean, default: false },
  },
  computed: {
    getChipColor() {
      if (this.isActive) return 'brandPrimary';
      return this.chipColor;
    },
  },
};

</script>

<style scoped lang="less">
.v-chip {
  font-weight: 400 !important;
  cursor: pointer !important;
  overflow: visible;
  transition: none;
}
.v-chip--pill {
  border-radius: 20px;
}
.v-chip.v-chip--size-default {
  font-size: 16px;
}
.v-chip:active:before {
  background-color: transparent !important;
}
.v-chip--active:before {
  background-color: transparent !important;
}
.v-chip--clickable:active {
  box-shadow: none;
}
.v-chip:hover:before {
    opacity: 0;
    transition: opacity .2s cubic-bezier(.4,0,.6,1);
}

.reduce-font {
  font-size: 14px !important;
}
</style>
